import { BucketPriority } from 'glance-datatypes';
import Utils from './Utils';

export default class JerseyRestApiService {
  static getAllActivePublishers(callback?: (publisherTable: any[]) => any) {
    $.ajax({
      type: 'GET',
      url: '/rest/api/v0/publisher/getallactive',
      contentType: false,
      processData: false,
      success: function(dataResponse) {
        callback(dataResponse);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
        callback(null);
      },
    });
  }

  static getSegmentQueries() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/rest/api/v0/segmentquery/all`,
        contentType: false,
        processData: false,
        success: function(segmentQueries) {
          resolve(segmentQueries);
        },
        error: function(error) {
          console.error(error);
          reject(error);
        },
      });
    });
  }

  static getAllSegmentSource() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: '/rest/api/v0/value/segment-source/all',
        contentType: false,
        processData: false,
        success: function(segmentSources) {
          resolve(segmentSources);
        },
        error: function(error) {
          console.error(error);
          reject(error);
        },
      });
    });
  }

  static getAllSegmentTargets() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: '/rest/api/v0/value/segment-target/all',
        contentType: false,
        processData: false,
        success: function(segmentTargets) {
          resolve(segmentTargets);
        },
        error: function(error) {
          console.error(error);
          reject(error);
        },
      });
    });
  }

  static addSegmentQuery(payload) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/rest/api/v0/segmentquery/add',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        success: function(dataResponse) {
          resolve(dataResponse);
        },
        error: function(error) {
          reject(error);
        },
      });
    });
  }

  static updateSegmentQuery(payload) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/rest/api/v0/segmentquery/update',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        success: function(dataResponse) {
          resolve(dataResponse);
        },
        error: function(error) {
          reject(error);
        },
      });
    });
  }

  static getAllDrafts(payload) {
    return new Promise((resolve, reject) => {
      const {
        limit = 10,
        offset = 0,
        categoryIds,
        publisherId,
        createdAfterSeconds,
        type,
      } = payload;

      $.ajax({
        type: 'POST',
        url: `/rest/api/v0/glancestore/draft`,
        contentType: 'application/json',
        data: JSON.stringify({
          categoryIds,
          publisherId,
          createdAfterSeconds,
          type,
          limit,
          offset,
        }),
        success: function(drafts) {
          const { results } = drafts;
          resolve(results);
        },
        error: function(error) {
          reject(error);
        },
      });
    });
  }

  static getDraftsByPartnerAndRegion(payload) {
    return new Promise((resolve, reject) => {
      const {
        limit = 10,
        offset = 0,
        categoryIds,
        publisherId,
        createdAfterSeconds,
        type,
        partnerId,
        region,
        isPublished,
      } = payload;

      $.ajax({
        type: 'POST',
        url: `/rest/api/v0/glancestore/draft/meta`,
        contentType: 'application/json',
        data: JSON.stringify({
          categoryIds,
          createdAfterSeconds,
          type,
          limit,
          offset,
          partnerId,
          region,
          isPublished,
          publisherId,
        }),
        success: function(drafts) {
          const { results } = drafts;
          resolve(results);
        },
        error: function(error) {
          reject(error);
        },
      });
    });
  }

  static getGlances(data, successCallback, errorCallback) {
    const { limit = 10, offset = 0 } = data;
    const { partnerId, search, type, state, region, isExpiry } = data;
    $.ajax({
      type: 'POST',
      url: `/rest/api/v0/glancestore/pair`,
      contentType: 'application/json',
      data: JSON.stringify({
        partnerId,
        search,
        type,
        state,
        region,
        isExpiry,
        limit,
        offset,
      }),
      success: function(glances) {
        successCallback(glances);
      },
      error: function(error) {
        errorCallback(error);
      },
    });
  }

  static getInternalGlances(data, successCallback, errorCallback) {
    const {
      search,
      type,
      state,
      region,
      isExpiry,
      categoryIds,
      publisherId,
      storyType,
      limit,
      offset,
      isWebpeek,
    } = data;
    $.ajax({
      type: 'POST',
      url: `/rest/api/v0/glancestore/data/meta`,
      contentType: 'application/json',
      data: JSON.stringify({
        search,
        type,
        state,
        region,
        isExpiry,
        limit,
        offset,
        categoryIds,
        publisherId,
        storyType,
        isWebpeek,
      }),
      success: function(glances) {
        successCallback(glances);
      },
      error: function(error) {
        errorCallback(error);
      },
    });
  }

  static approveInternalGlances(
    region: String,
    glanceIds: String[],
    callback?: (success: boolean) => void,
  ) {
    $.ajax({
      type: 'POST',
      url: `/rest/api/v0/internal/approval/approve?region${region}`,
      contentType: 'application/json',
      data: JSON.stringify(glanceIds),
      success: function(dataResponse) {
        callback(true);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
        callback(false);
      },
    });
  }

  static rejectInternalGlances(
    region: String,
    rejectReason: String,
    glanceIds: String[],
    callback?: (success: boolean) => void,
  ) {
    $.ajax({
      type: 'POST',
      url: `/rest/api/v0/internal/approval/reject?region=${region}&rejectReason=${rejectReason}`,
      contentType: 'application/json',
      data: JSON.stringify(glanceIds),
      success: function(dataResponse) {
        callback(true);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
        callback(false);
      },
    });
  }

  static uploadFileToBlob(payload) {
    const { folderPath, subFolderPath, formData } = payload;
    const append = subFolderPath === '-1' ? '' : `/${subFolderPath}`;

    const path = `${folderPath}${append}`;

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: `/rest/api/v0/upload/file?path=${path + '/'}`,
        processData: false,
        contentType: false,
        data: formData,
        success: function(response, textStatus, xhr) {
            resolve({ message: response, statusCode: xhr.status });
          },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          reject(XMLHttpRequest.statusText);
        },
      });
    });
  }

  static targetUserNotification(payload) {
    const { formData } = payload;

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: `/rest/api/v0/fcm/user/file`,
        processData: false,
        contentType: false,
        data: formData,
        success: function(response) {
          resolve(response);
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          reject(XMLHttpRequest.statusText);
        },
      });
    });
  }

  static getAllPublishers(callback?: (publisherTable: any[]) => any) {
    $.ajax({
      type: 'GET',
      url: '/rest/api/v0/publisher/getall',
      contentType: false,
      processData: false,
      success: function(dataResponse) {
        callback(dataResponse);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
        callback(null);
      },
    });
  }

  static removePublisher(publisherId: String) {
    $.ajax({
      type: 'GET',
      url: '/rest/api/v0/publisher/' + publisherId + '/remove',
      contentType: false,
      processData: false,
      success: function(dataResponse) {},
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
      },
    });
  }

  static sendNotification(settings: any, callback?: (response: any) => void) {
    const requestData = JSON.stringify(settings);
    $.ajax({
      type: 'GET',
      url: '/rest/api/v0/fcm/user/engage',
      data: { userEngageNotification: requestData, view: settings.view },
      success: function(dataResponse) {
        console.log(dataResponse);
        callback(dataResponse);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
      },
    });
  }

  static addPublisher(
    newPublisher: String,
    callback?: (response: any) => void,
  ) {
    $.ajax({
      type: 'GET',
      url: '/rest/api/v0/publisher/add',
      data: {
        publisher: newPublisher,
      },
      success: function(dataResponse) {
        callback(dataResponse);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
      },
    });
  }

  static updatePublisher(
    newPublisher: String,
    callback?: (response: any) => void,
  ) {
    $.ajax({
      type: 'GET',
      url: '/rest/api/v0/publisher/update',
      data: {
        publisher: newPublisher,
      },
      success: function(dataResponse) {
        callback(dataResponse);
      },
      error: function(response) {
        console.error(response);
        JerseyRestApiService.handlerError(response);
      },
    });
  }

  static getCampaignObjectives() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/rest/api/v0/value/campaign-objective/all`,
        contentType: false,
        processData: false,
        success: function(campaignObjectives) {
          resolve(campaignObjectives);
        },
        error: function(error) {
          console.error(error);
          reject(error);
        },
      });
    });
  }

  static getSearchBubbles(val: string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/rest/api/v0/bubble/search?q=${val}&limit=10`,
        contentType: false,
        processData: false,
        success: function(data) {
          const filteredData = data.map((item) => {
            const {
              bubbleId,
              name,
              qualifier,
              imagePath,
              storyCount,
              glanceType,
              adCoefficient,
              bucketPriority,
              ecpm,
            } = item;
            return {
              bubbleId,
              name,
              qualifier,
              imagePath,
              storyCount,
              glanceType,
              adCoefficient,
              bucketPriority,
              ecpm,
            };
          });
          resolve(filteredData);
        },
        error: function(error) {
          console.error(error);
          reject(error);
        },
      });
    });
  }

  static getBubbleById(id: string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/rest/api/v0/bubble/?ids=${id}`,
        contentType: false,
        processData: false,
        success: function(data) {
          const transformedData = data.reduce((acc, val) => {
            acc[val.bubbleId] = val;
            return acc;
          }, {});
          resolve(transformedData);
        },
        error: function(error) {
          console.error(error);
          reject(error);
        },
      });
    });
  }

  static getAvailableRank = (bubbleId: string) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/rest/api/v0/bubble/filledStorySlots?bubbleId=${bubbleId}`,
        contentType: false,
        processData: false,
        success: (data) => {
          resolve(data);
        },
        error: (error) => {
          console.error(error);
          reject(error);
        },
      });
    });
  };

  static getCityStates = () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/rest/api/v0/targetingrules/all-defaults`,
        contentType: false,
        processData: false,
        success: (data) => {
          resolve(data);
        },
        error: (error) => {
          console.error(error);
          reject(error);
        },
      });
    });
  };

  static handlerError(result: any) {
    Utils.openNewTab(
      '/#/error?html=' + encodeURIComponent(result.responseText),
    );
  }
}



// WEBPACK FOOTER //
// ./src/JerseyRestApiService.tsx